export default "__VITE_ASSET__BHRYXZ11__"